import { gql } from "@apollo/client";

export const CHANGE_PASSWORD =gql`
mutation ChangePassword($data: ChangePasswordInput!, $where: ChangePasswordWhereInput!) {
  changePassword(data: $data, where: $where) {
    status
  }
}
`;